import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { listFeaturedProducts } from "../../Redux/Actions/ProductActions";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const FeaturedProductsCarousel = () => {
  const dispatch = useDispatch();

  const productFeaturedList = useSelector((state) => state.productFeaturedList);
  const { loading, error, products = [] } = productFeaturedList;

  useEffect(() => {
    dispatch(listFeaturedProducts(12));
  }, [dispatch]);

  const formatCOP = (value) =>
    new Intl.NumberFormat("es-CO").format(Number(value || 0));

  if (loading) return <Loading />;
  if (error) return <Message variant="alert-danger">{error}</Message>;
  if (!products.length) return null;

  return (
    <section className="featured-products-section">
      <div className="site-shell">
        <div className="site-shell-inner">
          <div className="featured-products-header">
            <h2 className="featured-products-title">Destacados</h2>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            navigation
            loop={true}
            autoplay={{ delay: 3000 }}
            spaceBetween={16}
            breakpoints={{
              0: { slidesPerView: 1 }, // 🔥 FIX móvil
              520: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1100: { slidesPerView: 4 },
              1400: { slidesPerView: 5 },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product._id}>
                <div className="shop-card">
                  <div className="border-product">
                    <Link to={`/products/${product._id}`}>
                      <div className="shopBack">
                        {product.discount > 0 && (
                          <span className="shop-discount-badge">
                            -{product.discount}%
                          </span>
                        )}
                        <img src={product.image} alt={product.name} />
                      </div>
                    </Link>

                    <div className="shoptext">
                      <p>
                        <Link to={`/products/${product._id}`}>
                          {product.name}
                        </Link>
                      </p>

                      <div className="shop-price-row">
                        <h3 className="shop-price-discounted">
                          ${formatCOP(product.discountedPrice)}
                        </h3>

                        {product.discount > 0 && (
                          <span className="shop-price-original">
                            ${formatCOP(product.price)}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProductsCarousel;
